import { Injectable } from '@angular/core';

import { AutocompleteService } from '../../../..//Domain/Port/autocomplete.service';
import { GoogleAutocompleteResultToAddressMapperService } from '../../../..//Infrastructure/Adapter/Google/Autocomplete/Mapper/google-autocomplete-result-to-address.mapper';
import { Address } from '../../../../Domain/Model/address';

@Injectable({
    providedIn: 'root'
})
export class GoogleAutocompleteService extends AutocompleteService {
    constructor(private readonly mapper: GoogleAutocompleteResultToAddressMapperService) {
        super();
    }

    override async getAutoCompleteAddresses(input: string): Promise<Address[]> {
        if (!input.trim()) {
            return [];
        }

        try {
            await google.maps.importLibrary('places');
            const sessionToken = new google.maps.places.AutocompleteSessionToken();
            const predictions = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
                input: input,
                includedRegionCodes: ['us'],
                language: 'en-US'
            });

            return this.mapper.map(predictions.suggestions, sessionToken);
        } catch (error) {
            console.error('Error in getAutoCompleteAddresses:', error);
            return [];
        }
    }
}
